import { DependencyList, useEffect, useMemo } from 'react';
import { UIMatch, useLocation, useMatches } from 'react-router';
import { create } from 'zustand';

export const useBreadcrumbs = () => {
    // const { breadcrumbs } = useBreadcrumb();
    const breadcrumbs = useCustomBreadcrumbStore(state => state.breadcrumbs);

    const mm = useMatches() as UIMatch<any, any>[];
    const crumbs = useMemo(() => {
        // console.log('mm', mm);
        // console.log('breadcrumbs', breadcrumbs);
        const firstParts = mm
            // first get rid of any matches that don't have handle and crumb
            ////@ts-expect-error
            .filter(match => Boolean(match.handle?.crumb))
            // now map them into an array of elements, passing the loader
            // data to each one
            ////@ts-expect-error
            .map(match => {
                return { path: match.pathname, label: match.handle.crumb };
            });

        const output = [
            ...firstParts.filter((fp, i) => !breadcrumbs.find(b => b.path === fp.path)),
            ...breadcrumbs.filter(b => b.label), // filter out empty labels
        ];
        // console.log('breadcrumbs', output);
        return output;
    }, [mm, breadcrumbs]);

    return crumbs;
};

export type BreadcrumbsType = { path: string; label: string };

interface CustomBreadcrumbState {
    breadcrumbs: BreadcrumbsType[];
    setBreadcrumbs: (breadcrumbs: BreadcrumbsType[]) => void;
}

const useCustomBreadcrumbStore = create<CustomBreadcrumbState>(set => ({
    breadcrumbs: [],
    setBreadcrumbs: breadcrumbs => set({ breadcrumbs }),
}));

export const useSetCustomBreadcrumb = (label?: string | BreadcrumbsType[]) => {
    const setBreadcrumbs = useCustomBreadcrumbStore(state => state.setBreadcrumbs);
    useEffect(() => {
        if (!label) return;
        // const setState = useCustomBreadcrumbStore.setState;
        const location = window.location.pathname;
        const newLocation = location.startsWith('/admin') ? location.slice(6) : location;
        if (typeof label === 'string') {
            setBreadcrumbs([{ path: newLocation, label }]);
        } else {
            setBreadcrumbs(label);
        }

        // clear on unmount
        return () => {
            setBreadcrumbs([]);
        };
    }, [label, setBreadcrumbs]);
};
